import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

function Spinner({ message }) {
  return (
    <div className="fixed top-0 left-0 z-20 w-full h-full flex flex-col justify-center items-center bg-[#DBEBA2] bg-opacity-60">
      <Spin
        className=""
        indicator={<LoadingOutlined className="text-[#5A741DDD] text-7xl" />}
      />
      <p className="app-text text-2xl text-center my-12 font-semibold">
        {message ? message : " Loading..."}
      </p>
    </div>
  );
}

export default Spinner;
